import { Injectable } from "@angular/core";
import { ColumnSelectLabel } from "@common/facet";
import { BaseTableColumnsHelper } from "@common/util/table-columns/base-table-columns-helper";

@Injectable()
export class TaskOutlineTableColumnsHelper extends BaseTableColumnsHelper {
    static visibleColumns = {
        protocol: true,
            taskDefinition: true,
            taskAlias: true,
            cohorts: true,
            individualAnimals: true,
            sampleGroups: true,
            individualSamples: true,
            status: true
    }

    constructor() {
        super(Object.assign({}, TaskOutlineTableColumnsHelper.visibleColumns));
    }
    
    protected setupColumnSelectLabels(activeFields: Set<string>): void {
        this.columnSelectLabels = [
            new ColumnSelectLabel('protocol', 'Protocol'),
            new ColumnSelectLabel('taskDefinition', 'Task'),
            new ColumnSelectLabel('taskAlias', 'Task Name'),
            new ColumnSelectLabel('cohorts', 'Cohort'),
            new ColumnSelectLabel('individualAnimals', 'Individual Animal'),
            new ColumnSelectLabel('sampleGroups', 'Sample Group'),
            new ColumnSelectLabel('individualSamples', 'Individual Sample'),
            new ColumnSelectLabel('status', 'Progress')
        ]
    }
}